import { Box, Typography } from "@mui/material";
import React from "react";
import {
  getGroupedSectionsForPlan,
  getSectionsUnlockedAtPlan,
} from "../../constants/subscriptionPlanSections";

interface PlanSectionsListProps {
  planCode: string;
  /** When true, only show sections that unlock at this plan tier. */
  showUnlockedOnly?: boolean;
  title?: string;
  dense?: boolean;
}

const PlanSectionsList: React.FC<PlanSectionsListProps> = ({
  planCode,
  showUnlockedOnly = false,
  title = "Included sections:",
  dense = false,
}) => {
  const groups = showUnlockedOnly
    ? [
        {
          hub: "platform" as const,
          hubLabel: "Unlocked with this plan",
          sections: getSectionsUnlockedAtPlan(planCode),
        },
      ].filter((g) => g.sections.length > 0)
    : getGroupedSectionsForPlan(planCode);

  if (groups.length === 0) {
    return null;
  }

  return (
    <Box mt={dense ? 1.5 : 2}>
      <Typography
        variant="subtitle2"
        sx={{ color: "#1e293b", fontWeight: 600, mb: 1 }}
      >
        {title}
      </Typography>
      {groups.map((group) => (
        <Box key={group.hub} sx={{ mb: dense ? 1 : 1.5 }}>
          {!showUnlockedOnly && (
            <Typography
              variant="caption"
              sx={{
                color: "#94a3b8",
                fontWeight: 700,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                display: "block",
                mb: 0.5,
              }}
            >
              {group.hubLabel}
            </Typography>
          )}
          {group.sections.map((section) => (
            <Typography
              key={section.id}
              variant="body2"
              sx={{
                color: "#64748b",
                mb: 0.35,
                display: "flex",
                alignItems: "center",
                lineHeight: 1.4,
                "&:before": {
                  content: '"✓"',
                  color: "#dc2626",
                  fontWeight: "bold",
                  marginRight: "8px",
                  flexShrink: 0,
                },
              }}
            >
              {section.label}
            </Typography>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default PlanSectionsList;
